var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.6528C0 4.19497 0.372115 3.80806 0.8698 3.74847L15.4349 2.00396C15.7344 1.96809 16 2.18067 16 2.45612V5.12859H0V4.6528Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.4967V16.5297C0 17.0334 0.447715 17.4418 1 17.4418H19C19.5523 17.4418 20 17.0334 20 16.5297V6.4967H0ZM17 10.6011C17 11.3567 16.3284 11.9693 15.5 11.9693C14.6715 11.9693 14 11.3567 14 10.6011C14 9.84549 14.6715 9.23298 15.5 9.23298C16.3284 9.23298 17 9.84549 17 10.6011Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletFill);
export default __webpack_public_path__ + "static/media/wallet_fill.7dbfccdc22429aaa2fbf442f16f5066a.svg";
export { ForwardRef as ReactComponent };